let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cbpTs")).then(() => parcelRequire('h0tp7'));